import { type FC, type ReactNode } from 'react'

import { Screen, VStack, type ScreenProps } from '@/components'

export interface ConstrainedScreenProps extends ScreenProps {
  children: ReactNode
}

export const ConstrainedScreen: FC<ConstrainedScreenProps> = ({ children, ...props }) => (
  <Screen
    footerClassName='w-full max-w-screen-sm self-center'
    withCenterHorizontal
    withGap={false}
    withPadding={false}
    {...props}
  >
    <VStack
      // limit the content to be the size of a 640px (sm) wide screen
      className='pb-safe-or-4 w-full max-w-screen-sm flex-1 gap-4 p-4 web:pb-4'
    >
      {children}
    </VStack>
  </Screen>
)
